import * as React from 'react';
import omit from 'lodash/omit';
import classNames from 'classnames';
import Element from './Element';
import ConfigContext from '../config-provider/ConfigContext';
const SkeletonButton = function SkeletonButton(props) {
    const { prefixCls: customizePrefixCls, className, active } = props;
    const { getPrefixCls } = React.useContext(ConfigContext);
    const prefixCls = getPrefixCls('skeleton', customizePrefixCls);
    const cls = classNames(prefixCls, className, `${prefixCls}-element`, {
        [`${prefixCls}-active`]: active,
    });
    return (React.createElement("div", { className: cls },
        React.createElement(Element, Object.assign({ prefixCls: `${prefixCls}-button` }, omit(props, ['prefixCls'])))));
};
SkeletonButton.displayName = 'SkeletonButton';
SkeletonButton.defaultProps = {
    size: 'default',
};
export default React.memo(SkeletonButton);
